/* eslint-disable @typescript-eslint/ban-types */
import { CheckboxProps } from '@mui/material';
import { Control, Controller, Path, RegisterOptions } from 'react-hook-form';

import LabelCheckbox, {
  LabelCheckboxProps,
} from '../LabelCheckbox/LabelCheckbox';

interface FormCheckboxProps<T> {
  name: Path<T>;
  control: Control<T, object>;
  rules?: RegisterOptions;
  LabelCheckboxProps?: LabelCheckboxProps;
  CheckboxProps?: CheckboxProps;
}

export const FormCheckbox = <T,>({
  name,
  control,
  rules,
  LabelCheckboxProps,
  CheckboxProps,
}: FormCheckboxProps<T>): JSX.Element => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <LabelCheckbox
        {...LabelCheckboxProps}
        CheckboxProps={{
          ...CheckboxProps,
          onChange: (e) =>
            field.onChange(
              e.target.checked && CheckboxProps?.value
                ? CheckboxProps?.value
                : e.target.checked
            ),
          value: CheckboxProps?.value,
          checked: (CheckboxProps?.value
            ? field.value === CheckboxProps?.value
            : field.value) as boolean,
        }}
      />
    )}
  />
);
